<template>
  <div>ben detayım ödeme {{this.$route.params.Odeme_id}}</div>
</template>

<script>
    export default {
        name: "detay",
        props: ["Odeme_id"],
        created() {
            console.log(this.$route.params.Odeme_id)
        }
    }
</script>



// WEBPACK FOOTER //
// src/Module/gider/odeme/detay.vue